import Axios from 'axios';


export const GetBannerAxios = async () => {
  let res = await Axios.get('/banners', { params: { pageSize: 999 } })
  return res.data
}
export const GetMoreWorkAxios = async () => {
  let res = await Axios.get('/moreWorks')
  return res.data
}
export const GetCourseContent = async () => {
  let res = await Axios.get('/courses')
  return res.data
}
export const getCoursePeriods = async id => {
  let res = await Axios.get(`/coursePeriods`, { params: { courseId: id } })
  return res.data
}
export const GetNewsContent = async (id, params) => {
  let res = await Axios.get(`/news/${id}`, { params: { top: 0, pageSize: 6, ...params } })
  return res.data
}
export const GetAllNewsContent = async (params) => {
  let res = await Axios.get(`/news`, { params: { pageSize: 6, ...params, } })
  return res.data
}
export const PostNewsContent = async (data) => {
  let res = await Axios.post(`/topnews`, data)
  return res.data
}
export const GetAssistList = async () => {
  let res = await Axios.get(`/assistans_detail`)
  return res.data
}
export const GetAssistantCollection = async () => {
  let res = await Axios.get(`/assistans-works`)
  return res.data
}
export const GetAllProblemList = async () => {
  let res = await Axios.get(`/common-problem`, { params: { pageSize: 999 } })
  return res.data
}

export const Searchkeyword = async (params) => {
  let res = await Axios.get(`/common-problem-search`, { params })
  return res.data
}
export const UserRecode = async (data) => {
  let res = await Axios.post(`/common-problem/read`, data)
  return res.data
}
export const PostIp = async () => {
  let res = await Axios.post(`/stage-local`)
  return res.data
}
export const GetSingleNew = async (id) => {
  let res = await Axios.get(`/new/${id}`)
  return res.data
}
export const GetSelfIndex = async (id) => {
  let res = await Axios.get(`/custom-page/${id}`)
  return res.data
}